module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info animated zoomIn",
    staticStyle: {
      "animation-duration": "0.5s"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_vm._t("icon"), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.title))])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._t("footer")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ae6b1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Box.vue
// module id = 1238
// module chunks = 1